import { createFileRoute } from "@tanstack/react-router";
import MFA from "../../../pages/MFA";

export const Route = createFileRoute("/admin/mfa/")({
  component: MFA,
});
